import { createRouter, createWebHistory } from "vue-router";
import Index from "@/views/index/index.vue";
import newsList from "@/views/news/index.vue";
import newsDetails from "@/views/news/detailsIndex.vue";
import Center from "@/components/center.vue";
import notaryServices from "@/views/notaryServices/index.vue";
import legalService from "@/views/legalService/index.vue";
import exhibitionHall from "@/views/exhibitionHall/index.vue";
import Login from '@/views/login.vue';
import Register from '@/views/register.vue';
import RegisterAgree from '@/views/registerAgree.vue';
import xshzList from '@/views/xshz/xshzList.vue'
import qyfn from '@/views/qyfn/qyfn.vue'
import xshzDetails from '@/views/xshz/xshzDetails.vue'
import aboutUs from '@/views/aboutUs/aboutUs.vue'
import logisticsServices from '@/views/logisticsServices/index.vue'
import foreignTrade from '@/views/foreignTrade/index.vue'
import trainServices from '@/views/trainServices/index.vue'
import trainServicesDetail from '@/views/trainServices/trainServicesDetail.vue'
import courseDetail from '@/views/trainServices/courseDetail.vue'
import sjzq from '@/views/sjzq/index.vue'
import roadTransport from '@/views/sjzq/roadTransport.vue'
import LoginYy from "@/views/loginYy.vue";
import h5notaryServices from "@/views/h5/notaryServices/index.vue";
import h5legalService from '@/views/h5/legalService/index.vue'
import h5exhibitionHall from '@/views/h5/exhibitionHall/index.vue'
import h5logisticsServices from '@/views/h5/logisticsServices/index.vue'
import h5trainServicesDetail from '@/views/h5/trainServices/trainServicesDetail.vue'
import h5foreignTrade from '@/views/h5/foreignTrade/index.vue'
import h5trainServices from '@/views/h5/trainServices/index.vue'
import h5sjzq from '@/views/h5/sjzq/index.vue'
import h5roadTransport from '@/views/h5/sjzq/roadTransport.vue'
import h5xshzList from '@/views/h5/sjzq/xshzList.vue'
import h5xshzDetails from '@/views/h5/sjzq/xshzDetails.vue'
import h5qyDetails from '@/views/h5/sjzq/qyDetails.vue'

let allRouter = [

  {
    name: "",
    path: "/",
    component: Center, 
    children: [
      {
        name: "首页",
        path: "",
        component: Index,
        meta: { mobileReady: true }
      },{
        name: "资讯",
        path: "/newsList",
        component: newsList,
        meta: { mobileReady: true }
      },
      {
        name: "资讯详情",
        path: "/newsDetails",
        component: newsDetails,
        meta: { mobileReady: true }
      },
      {
        name: "关于我们",
        path: "/aboutUs",
        component: aboutUs,
      },
      {
        name: "物流服务",
        path: "/logisticsServices",
        component:logisticsServices,
      },
      {
        name: "公证服务",
        path: "/notaryServices",
        component:notaryServices,
      },
      {
        name: "法律服务",
        path: "/legalService",
        component: legalService,
      }, 
      {
        name: "外贸服务",
        path: "/foreignTrade",
        component: foreignTrade,
      },
      {
        name: "培训服务",
        path: "/trainServices",
        component: trainServices,
      },
      {
        name: "企业赋能服务",
        path: "/qyfn",
        component: qyfn,
       
      },
      {
        name: "数据专区",
        path: "/sjzq",
        component: sjzq,
      },
      {
        name: "国际道路运输服务",
        path: "/roadTransport",
        component: roadTransport,
      },
       {
        name: "培训详情",
        path: "/trainServicesDetail",
        component: trainServicesDetail,
      },
      {
        name: "课程详情",
        path: "/courseDetail",
        component: courseDetail,
      },
      {
        name: "线上云展厅",
        path: "/exhibitionHall",
        component: exhibitionHall,
        meta: {
          FooterShow: true,   //是否显示页脚
        },
      },
      {
        name: "线上会展",
        path: "/xshzList",
        component: xshzList,
        meta: {
          FooterShow: true,   //是否显示页脚
        },
      },
     
      {
        name: "线上会展详情",
        path: "/xshzDetails",
        component: xshzDetails,
        meta: {
          FooterShow: true,   //是否显示页脚
        },
      },
      {
        name: "展会中心",
        path: "/exhibitionCenter",
        component: () => import("@/views/exhibition/exhibitionCenter.vue"),
      },
      {
        name: "展会动态详情",
        path: "/exhibitionCenterDetails",
        component: () => import("@/views/exhibition/exhibitionCenterDetails.vue"),

      },
      {
        name: "展会活动详情",
        path: "/exhibitionhdDetails",
        component: () => import("@/views/exhibition/exhibitionhdDetails.vue"),

      },
      {
        name: "展会详情",
        path: "/exhibitionDetails",
        component: () => import("@/views/exhibition/exhibitionDetails.vue"),

      },
      {
        name: "展会回顾",
        path: "/exhibitionReview",
        component: () => import("@/views/exhibition/exhibitionReview.vue"),

      },
      {
        name: "展会公告",
        path: "/exhibitionNotice",
        component: () => import("@/views/exhibition/exhibitionNotice.vue"),

      },
      {
        name: "展会VR",
        path: "/exhibitionVr",
        component: () => import("@/views/exhibition/exhibitionVrH5.vue"),
        meta: { mobileReady: true, FooterShow: true }
      },
      {
        name: "数据分析",
        path: "/datAnalysis",
        component: () => import("@/views/datAnalysis/datAnalysis.vue"),
      },
      {
        name: "一站式搜索",
        path: "/oneStopSearch",
        component: () => import("@/views/oneStopSearch/index.vue"),
     
        children:[
          {
            name: "搜索资讯",
            path: "/oneStopSearchNews",
            component: () => import("@/views/oneStopSearch/news.vue"),
            meta: { mobileReady: true }
          },
          {
            name: "会展",
            path: "/oneStopSearchExhibitions",
            component: () => import("@/views/oneStopSearch/exhibitions.vue"),
            meta: { mobileReady: true }
          },
          {
            name: "服务",
            path: "/oneStopSearchService",
            component: () => import("@/views/oneStopSearch/service.vue"),
            meta: { mobileReady: true }
          },
        ]
      },
      {
        name: "人才服务",
        path: "/talentServices",
        component: () => import("@/views/talentServices/index.vue"),
      },
      {
        name: "用户指南",
        path: "/userGuide",
        component: () => import("@/views/userGuide/index.vue"),
        meta: { mobileReady: true }
      },
      {
        name: "服务案例",
        path: "/serviceCase",
        component: () => import("@/views/serviceCase/index.vue"),
        meta: { mobileReady: true }
      }
    ]
  }, 
  {
    name: "登录",
    path: "/login",
    component: Login,
    meta: { mobileReady: true }
  },
  {
    name: "",
    path: "/h5",
    component: Center,
    children: [
      {
        name: "h5notaryServices",
        path: "notaryServices",
        component: h5notaryServices,
        meta: { mobileReady: true }
      },
      {
        name: "人才服务h5",
        path: "talentServices",
        component: () => import("@/views/h5/talentServices/index.vue"),
        meta: { mobileReady: true }
      },
        {
        name: "公证服务h5",
        path: "legalService",
        component: h5legalService,
        meta: { mobileReady: true }
      },
         {
        name: "vr展厅h5",
        path: "exhibitionHall",
        component: h5exhibitionHall,
        meta: { mobileReady: true }
      },
      {
        name: "物流服务h5",
        path: "logisticsServices",
        component: h5logisticsServices,
        meta: { mobileReady: true }
      },
      {
        name: "",
        path: "trainServicesDetail",
        component: h5trainServicesDetail,
        meta: { mobileReady: true }
      },
      {
        name: "h5sjzq",
        path: "sjzq",
        component: h5sjzq,
        meta: { mobileReady: true }
      },
      {
        name: "h5roadTransport",
        path: "roadTransport",
        component: h5roadTransport,
        meta: { mobileReady: true }
      },
      {
        name: "h5xshzList",
        path: "xshzList",
        component: h5xshzList,
        meta: { mobileReady: true }
      },
 
      {
        name: "h5xshzDetails",
        path: "xshzDetails",
        component: h5xshzDetails,
        meta: { mobileReady: true }
      },
      {
        name: "h5qyDetails",
        path: "qyDetails",
        component: h5qyDetails,
        meta: { mobileReady: true }
      },
      


      


      // {
      //   name: "线上会展",
      //   path: "/xshzList",
      //   component: xshzList,
      //   meta: {
      //     FooterShow: true,   //是否显示页脚
      //   },
      // },
      
      {
        name: "移动端外贸服务",
        path: "foreignTrade",
        component: h5foreignTrade,
        meta: { mobileReady: true }
      },
      {
        name: "移动端培训服务",
        path: "trainServices",
        component: h5trainServices,
        meta: { mobileReady: true }
      },
    ],
  },
  {
    path: '/iframeMes',
    name: 'iframe通信',
    component: () => import('@/views/iframeMes/index.vue')
  },
  {
    name: "运营登录",
    path: "/loginYy",
    component: LoginYy,
    meta: { mobileReady: true }
  }, {
    name: "注册",
    path: "/register",
    component: Register,
    meta: { mobileReady: true }
  }, {
    name: { label: "商通中心用户注册协议", moduleName: "商通中心用户注册协议" },
    path: "/registerAgree",
    component: RegisterAgree
  }, {
    name: { label: "隐私政策声明", moduleName: "隐私政策声明" },
    path: "/privacyPolicy", component: RegisterAgree
  },
  {
    name: { label: "法律声明", moduleName: "法律声明" },
    path: "/legaNotice", component: RegisterAgree
  },
  {
    name: { label: "用户中心", moduleName: "用户中心" },
    path: "/userCenter", component: () => import("@/views/userCenter/index.vue"),
  },

];

const router = createRouter({
  history: createWebHistory(process.env.NODE_ENV == 'test'? '/nfstzx/': '/'),
  routes: allRouter,
  scrollBehavior() {
    return { top: 0 };
  },
});

/**
 * 判断是否为移动端（宽度小于768px）
 */
const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 768;
};

/**
 * 检查H5路由组中是否存在对应路径
 */
const hasH5Route = (path) => {
  const h5Group = allRouter.find(r => r.path === '/h5');
  if (!h5Group || !h5Group.children) return false;
  
  // 移除开头的斜杠进行匹配
  const normalizedPath = path.replace(/^\/+/, '');
  
  return h5Group.children.some(child => {
    // 处理空路径的情况
    const childPath = child.path || '';
    // 支持带斜杠和不带斜杠的匹配
    return childPath === normalizedPath || 
           childPath === normalizedPath.replace(/\/+$/, '') ||
           `/${childPath}` === `/${normalizedPath}`;
  });
};

/**
 * 获取对应的PC端路径（移除/h5前缀）
 */
const getPcPath = (h5Path) => {
  return h5Path.replace(/^\/h5/, '') || '/';
};

/**
 * 获取对应的H5端路径（添加/h5前缀）
 */
const getH5Path = (pcPath) => {
  return `/h5${pcPath === '/' ? '' : pcPath}`;
};

/**
 * 核心逻辑：设备宽度路由守卫
 * 当宽度 >= 768 时，移除 /h5 前缀
 * 当宽度 < 768 时，增加 /h5 前缀
 */
router.beforeEach((to, from, next) => {
  const isMobileSize = isMobile();
  const isH5Path = to.path.startsWith('/h5');
  
  // 1. 宽屏设备 (>=768px) 访问了 /h5 路由 -> 移除 /h5 重定向到 PC 路由
  if (!isMobileSize && isH5Path) {
    const pcPath = getPcPath(to.path);
    return next({ path: pcPath, replace: true, query: to.query });
  }

  // 2. 移动端设备 (<768px) 访问了 PC 路由 -> 尝试重定向到 /h5 路由
  if (isMobileSize && !isH5Path) {
    const h5Path = getH5Path(to.path);
    
    if (hasH5Route(to.path)) {
      return next({ path: h5Path, replace: true, query: to.query });
    }
  }

  next();
});

/**
 * 窗口尺寸变化监听
 * 当用户调整浏览器大小时，自动切换路由
 */
if (typeof window !== 'undefined') {
  let resizeTimer = null;
  let lastIsMobile = isMobile();
  
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const currentIsMobile = isMobile();
      const currentPath = router.currentRoute.value.path;
      const currentQuery = router.currentRoute.value.query;
      
      // 只有当移动端/PC端状态发生变化时才处理
      if (currentIsMobile !== lastIsMobile) {
        lastIsMobile = currentIsMobile;
        
        // PC端状态：当前是H5路由，需要切换到PC路由
        if (!currentIsMobile && currentPath.startsWith('/h5')) {
          const pcPath = getPcPath(currentPath);
          router.replace({ path: pcPath, query: currentQuery });
        }
        
        // 移动端状态：当前是PC路由且存在对应的H5路由，需要切换到H5路由
        if (currentIsMobile && !currentPath.startsWith('/h5')) {
          if (hasH5Route(currentPath)) {
            const h5Path = getH5Path(currentPath);
            router.replace({ path: h5Path, query: currentQuery });
          }
        }
      }
    }, 300); // 防抖300ms，避免频繁切换
  });
}

// createRouteGuard(router);
export default router;